import { FC } from 'react';
import { IconProps, defaultIconProps } from './IconProps';

export const IconShieldCheck: FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M7.50065 9.58314L9.16732 11.2498L12.9173 7.49981M16.6673 9.99981C16.6673 14.0902 12.2057 17.0651 10.5823 18.0122C10.3978 18.1198 10.3056 18.1737 10.1754 18.2016C10.0744 18.2232 9.92695 18.2232 9.82592 18.2016C9.69573 18.1737 9.60349 18.1198 9.41899 18.0122C7.79562 17.0651 3.33398 14.0902 3.33398 9.99981V6.01448C3.33398 5.34822 3.33398 5.01509 3.44295 4.72873C3.53921 4.47576 3.69564 4.25004 3.8987 4.07109C4.12856 3.86851 4.44048 3.75154 5.06432 3.5176L9.53249 1.84204C9.70573 1.77707 9.79236 1.74459 9.88147 1.73171C9.96051 1.72029 10.0408 1.72029 10.1198 1.73171C10.2089 1.74459 10.2956 1.77707 10.4688 1.84204L14.937 3.5176C15.5608 3.75154 15.8727 3.86851 16.1026 4.07109C16.3057 4.25004 16.4621 4.47576 16.5584 4.72873C16.6673 5.01509 16.6673 5.34822 16.6673 6.01448V9.99981Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconShieldCheck.defaultProps = defaultIconProps;
